import { styled } from "styled-components";

export const Margin = styled.div`
  margin-bottom: 40px;
  margin-top: 20px;
`;
